<template>
  <validation-observer ref="simpleRules">
    <b-row>
      <b-col cols="12">
        <item-form />
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <image-card-tr />
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <image-card-en />
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <image-card-de />
      </b-col>
    </b-row>
    <b-button
      variant="primary"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </validation-observer>
</template>

<script>
import {
  BButton, BRow, BCol,
} from 'bootstrap-vue'

import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ItemForm from '@/views/Admin/Home_page/ItemForm.vue'
import ImageCardTr from '@/views/Admin/Home_page/elements/ImageCardTr.vue'
import ImageCardEn from '@/views/Admin/Home_page/elements/ImageCardEn.vue'
import ImageCardDe from '@/views/Admin/Home_page/elements/ImageCardDe.vue'

export default {
  name: 'HomePage',
  components: {
    ValidationObserver,
    BButton,
    BRow,
    BCol,
    ItemForm,
    ImageCardTr,
    ImageCardEn,
    ImageCardDe,
  },
  data() {
    return {
      required,
      imageUrl: this.$store.state.app.baseURL,
      itemsForm: false,
      selectItems: null,

    }
  },
  computed: {
    itemData() {
      return this.$store.getters['homePage/dataItem']
    },
    saveData() {
      return this.$store.getters['homePage/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.getData()
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
        this.getData()
      }
    },
  },
  created() {
    localize('tr')
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('homePage/getDataItem')
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.$store.dispatch('homePage/saveData', this.itemData)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
